const apiUrl = {
  ApiUrl: {
    'smallVideoPlayCount': '//m.dianping.com/smallvideo/api/topic/playcountVV',
    'getVideoInfo': '//m.dianping.com/detail/videoapi/loadVideoInfo',
    'getNoticeList': '//m.dianping.com/detail/videoapi/noticelist',
    'getComment': '//m.dianping.com/detail/videoapi/comment',
    'addView': '//m.dianping.com/detail/videoapi/addview',
    'getAuthorInfo': '//m.dianping.com/detail/videoapi/author',
    'getFooterNum': '//m.dianping.com/detail/videoapi/loadCount',
    'getShareVideoInfo': '//m.dianping.com/detail/videoapi/review',
    'getTopicInfo': '//m.dianping.com/detail/videoapi/topic',
    'getGoodShopInfo': '//m.dianping.com/detail/videoapi/topic/info',
    'getGoodShopInfoNav': '//m.dianping.com/detail/videoapi/goodshop/nav',
    'getGoodShopTopicList': '//m.dianping.com/detail/videoapi/topic/list',
    'getGoodShopVideoList': '//m.dianping.com/detail/videoapi/goodshop/videolist',
    'loadVideoAlbumItemInfo': '//m.dianping.com/detail/videoapi/loadVideoAlbumItemInfo',
    'load2FloorHeadpic': '//m.dianping.com/detail/videoapi/load2FloorHeadpic',
    'load2FloorCommentInfo': '//m.dianping.com/detail/videoapi/load2FloorCommentInfo',
    'reportContent': '//m.dianping.com/detail/videoapi/reportContent',
    'loadAuthorVideoList':'//m.dianping.com/detail/videoapi/author/videolist',
    'loadTopicInfo': '//m.dianping.com/detail/videoapi/author/topicInfo',
    'getRelateVideoList': '//m.dianping.com/detail/videoapi/getRelateVideoList'
  },
  DebuggerUrl: {
    'smallVideoPlayCount': '//m.51ping.com/smallvideo/api/topic/playcountVV',
    'getVideoInfo': '//m.51ping.com/detail/videoapi/loadVideoInfo',
    'getNoticeList': '//m.51ping.com/detail/videoapi/noticelist',
    'getComment': '//m.51ping.com/detail/videoapi/comment',
    'addView': '//m.51ping.com/detail/videoapi/addview',
    'getAuthorInfo': '//m.51ping.com/detail/videoapi/author',
    'getFooterNum': '//m.51ping.com/detail/videoapi/loadCount',
    'getShareVideoInfo': '//m.51ping.com/detail/videoapi/review',
    'getTopicInfo': '//m.51ping.com/detail/videoapi/topic',
    // FIXME: 商家好店 短视频专题
    // 'getGoodShopInfo': '//gil.51ping.com:8080/detail/videoapi/topic/info',
    // 'getGoodShopInfoNav': '//gil.51ping.com:8080/detail/videoapi/goodshop/nav',
    // 'getGoodShopTopicList': '//gil.51ping.com:8080/detail/videoapi/topic/list',
    // 'getGoodShopVideoList': '//gil.51ping.com:8080/detail/videoapi/goodshop/videolist',
    'getGoodShopInfo': '//m.51ping.com/detail/videoapi/topic/info',
    'getGoodShopInfoNav': '//m.51ping.com/detail/videoapi/goodshop/nav',
    'getGoodShopTopicList': '//m.51ping.com/detail/videoapi/topic/list',
    'getGoodShopVideoList': '//m.51ping.com/detail/videoapi/goodshop/videolist',
    'loadVideoAlbumItemInfo': '//m.51ping.com/detail/videoapi/loadVideoAlbumItemInfo',
    'load2FloorHeadpic': '//m.51ping.com/detail/videoapi/load2FloorHeadpic',
    'load2FloorCommentInfo': '//m.51ping.com/detail/videoapi/load2FloorCommentInfo',
    // 'loadVideoAlbumItemInfo': '//gil.51ping.com:8080/detail/videoapi/loadVideoAlbumItemInfo',
    // 'load2FloorHeadpic': '//tang.51ping.com:8080/detail/videoapi/load2FloorHeadpic',
    // 'load2FloorCommentInfo': '//gil.51ping.com:8080/detail/videoapi/load2FloorCommentInfo',
    'reportContent': '//m.51ping.com/detail/videoapi/reportContent',
    'loadAuthorVideoList': '//m.51ping.com/detail/videoapi/author/videolist',
    'loadTopicInfo': '//m.51ping.com/detail/videoapi/author/topicInfo',
    // 'getRelateVideoList': '//tang.51ping.com:8080/detail/videoapi/getRelateVideoList'
    'getRelateVideoList': '//m.51ping.com/detail/videoapi/getRelateVideoList'
  },
  forwardUrl:{
    'authorHref': 'https://evt.dianping.com/synthesislink/13326.html?id=',
    'detailHref': 'https://evt.dianping.com/synthesislink/13433.html?id=',
    // 'shopHref': 'https://evt.dianping.com/synthesislink/13290.html?id=',
    'shopHref': 'https://evt.dianping.com/synthesislink/16056.html?id=',// cpx utm_source
    'dishSkuHref': 'https://evt.dianping.com/synthesislink/13291.html?id=',
    'beautySkuHref': 'https://evt.dianping.com/synthesislink/13292.html?id=',
    'joyTechHref': 'https://evt.dianping.com/synthesislink/13293.html?id=',
    'beautyTechHref': 'https://evt.dianping.com/synthesislink/13295.html?id=',
    'teacherHref': 'https://evt.dianping.com/synthesislink/13294.html?id=',
    'movieHref': 'https://evt.dianping.com/synthesislink/19365.html?id=',
    'H5VideoHref': 'https://h5.dianping.com/app/app-video-mobile/index.html?videoId='
  }
}
export default apiUrl



// WEBPACK FOOTER //
// ./src/libs/apiUrl.js